<template>
    <div class="input">
        <div class="input__box">
            <div
                :class="
                    `input__label label ${
                        validation.state === false ? 'invalid' : ''
                    }`
                "
            >
                <span>{{ label }}</span>
                <i :class="`fas ${arrow}`" />
            </div>
            <b-form-input
                trim
                size="sm"
                type="text"
                :value="value"
                :state="validation.state"
                @input="$emit('update', $event)"
            />
        </div>
        <b-form-invalid-feedback :state="validation.state">
            <div class="float-right">
                <div v-if="!validation.required">
                    {{ $t('form.validations.answerRequired') }}
                </div>
                <div v-if="!validation.maxLength">
                    {{ $t('form.validations.maxLength', { value: 80 }) }}
                </div>
            </div>
        </b-form-invalid-feedback>
    </div>
</template>
<script>
import i18n from '@/i18n'
export default {
    props: {
        isAxisX: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: null,
        },
        validation: {
            type: Object,
            required: true,
        },
    },
    computed: {
        label() {
            return this.isAxisX ? i18n.t('nBox.xAxis') : i18n.t('nBox.yAxis')
        },
        arrow() {
            return this.isAxisX ? 'fa-arrow-right' : 'fa-arrow-up'
        },
    },
}
</script>
<style lang="sass" scoped>
.input
    padding: 6px
    background: #edf0f1
    max-width: 400px

.input__box
    display: flex

.input__label
    display: flex
    min-width: 70px
    margin-right: 1.5rem
    align-items: center
    justify-content: space-between

.invalid
    color: #f86c6b !important

.invalid-feedback
    min-height: 10px
</style>
